/** The smallest a name is ever set, however long its longest word. */
export const NAME_MIN_PX = 36;

/**
 * The poster rule for a name: the size its CSS asks for, unless the longest
 * word would not fit the line, and then exactly the size at which it does.
 * Wrapping between words is fine (a stacked name is still a poster); breaking
 * inside one is not. Never below `min`.
 */
export function fitNameSize({
  max,
  min = NAME_MIN_PX,
  width,
  word,
}: {
  /** The size the stylesheet sets, in px. */
  max: number;
  min?: number;
  /** The width the name has, in px. */
  width: number;
  /** The widest word's width when set at `max`, in px. */
  word: number;
}): number {
  if (word <= width || word <= 0) return max;
  return Math.max(min, Math.floor((max * width) / word));
}
